import RedditSubredditResearch from '@/components/reddit/RedditSubredditResearch'

export default function RedditResearchPage() {
  return <RedditSubredditResearch />
} 